import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store/store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { isLoggedIn } from "@/common/authentication/auth";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  // If there is a meta field
  if (to.meta) {
    // If the route doesn't allow anonymous connections and they are not logged in
    if (!to.meta.allowAnon && !isLoggedIn()) {
      // Redirect them to login
      next({
        path: "/login",
      });
    } else {
      // Either they are signed in or this route allows anonymous connections
      next();
    }
  } else {
    // If they are not signed in and the route doesn't have meta data
    if (!isLoggedIn()) {
      // Redirect them to the login
      next({
        path: "/login",
      });
    } else {
      // They are signed in
      next();
    }
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
